<template>
  <el-table :data="tableData" stripe style="width: 100%" ref="stationTable" border v-loading="stationsLoading">
    <af-table-column prop="id" :label="$t('siteManager.ChargingStationNumber')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('siteManager.stationName')"></af-table-column>
    <af-table-column prop="stationCode" :label="$t('siteManager.stationCode')"></af-table-column>
    <af-table-column prop="operatorName" :label="$t('siteManager.operatorName')"></af-table-column>
    <af-table-column prop="city" :label="$t('siteManager.city')"></af-table-column>
    <af-table-column width="60" prop="pileCount" :label="$t('siteManager.pileCount')"></af-table-column>
    <af-table-column width="80" prop="dutyPerson" :label="$t('siteManager.dutyPerson')"></af-table-column>
    <af-table-column width="100" prop="dutyPersonPhone" :label="$t('siteManager.dutyPersonPhone')"></af-table-column>
    <af-table-column prop="serviceBillingRulesName"  :label="$t('siteManager.serviceBillingRulesName')"></af-table-column>
    <af-table-column width="60" prop="stationType.message" :label="$t('siteManager.stationType')"></af-table-column>
    <af-table-column width="100" :label="$t('siteManager.runningState')">
      <template slot-scope="{row}">
        <div v-if="row.stationStatus">
          <el-tag :type="row.stationStatus.code | statusFilter">
            {{ row.stationStatus.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <!--                <af-table-column width="80" prop="canUse.message" label="是否启用"></af-table-column>-->
    <af-table-column width="150px" :label="$t('siteManager.parkPrices')">
      <template slot-scope="scope">
        <div v-if="scope.row.parkPrices">
              <span
                style="display: inline-block"
                v-for="(item, i) in JSON.parse(scope.row.parkPrices)"
                :key="i"
              >
                {{ item[0] }} {{ $t('siteManager.to') }} {{ item[1] }} {{ $t('siteManager.unitPrice') }}:{{ item[2] }}{{ $t('siteManager.yuan') }}
              </span>
        </div>
      </template>
    </af-table-column>
    <af-table-column  v-if="checkPermission(['bee:res:station:parkPricesChange'])" width="200px"  :label="$t('siteManager.parkPricesChange')">
      <template slot-scope="scope">
        <el-popover style="margin-right: 10px" placement="left" width="200" >
          <el-form :model="parkPricesForm" :rules="parkPricesFormRules" ref="parkPricesForm"  size="mini">
          <el-col>
            <el-form-item prop="parkPrices">
              <el-col v-for="(item, i) in parkPrices" :key="i">
                <el-time-select
                  class="parkPricesPicker"
                  :placeholder="$t('siteManager.StartingTime')"
                  v-model="item[0]"
                  :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '24:00',
                            minTime: i > 0 && parkPrices[i - 1][1] ? parkPrices[i - 1][1].split(':')[0] + ':' + (parkPrices[i - 1][1].split(':')[1] - 1): '',
                          }"
                ></el-time-select>
                <el-time-select
                  class="parkPricesPicker"
                  :placeholder="$t('siteManager.EndTime')"
                  v-model="item[1]"
                  :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '24:00',
                            minTime: parkPrices[i][0],
                          }"
                ></el-time-select>
                <el-input autocomplete="off" v-model="item[2]" :placeholder="$t('siteManager.unitPrice2')"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item
              hidden
              label="id"
              :label-width="formLabelWidth"
              prop="id"
            >
              <el-input
                v-model="parkPricesForm.id"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
          <div style="text-align: center">
            <el-button
              type="success"
              size="mini"
              @click="addParkPrices"
            >{{$t('siteManager.add')}}</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="deleteParkPrices"
            >{{$t('siteManager.delete')}}</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="parkPricesSubmit(scope.$index, scope.row)"
              :loading="parkPricesSubmitLoading"
            >{{$t('siteManager.setUp')}}</el-button
            >
          </div>
          <el-button
            slot="reference"
            size="mini"
            class="parkPrices"
            plain
            @click="parkPricesCharging(scope.$index, scope.row)"
          >{{$t('siteManager.SetLockRate')}}
          </el-button>
        </el-popover>
      </template>
    </af-table-column>
    <af-table-column :label="$t('siteManager.operation')" width="320px">
      <template slot-scope="scope">
        <template v-if="scope.row.serviceBillingRulesId != null &&  scope.row.stationType.code != '301'">
          <el-button size="mini" type="success"  @click="rateEdit(scope.row.serviceBillingRulesId)">{{$t('siteManager.editRate')}}</el-button>
        </template>
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   >{{$t('siteManager.view')}}
        </el-button>
        <el-button size="mini" plain @click="stationEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:updateStation'])">{{$t('siteManager.edit')}}
        </el-button>
        <el-button size="mini" plain type="danger" @click="stationDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:deleteStation'])">{{$t('siteManager.delete')}}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  import stationApi from '../../../resourceCenter/api/stationApi'
  export default {
    name: "list",
    data(){
      return{
        parkPricesFormRules: {
          parkPrices: [
            {
              require: true,
              message: this.$t('siteManager.TimeCannotBeEmpty'),
              trigger: "blur",
            },
          ],
        },
        formLabelWidth: "150px",
        parkPricesForm: {},
        parkPricesSubmitLoading: false,
        parkPrices: [["00:00", "24:00",0]],
      }
    },
    props:{
      tableData: {},
      stationsLoading: false,
    },
    methods:{
      parkPricesCharging(index, row) {
        console.log(row.parkPrices);
        if (row.parkPrices == "" || row.parkPrices == null) {
          this.parkPrices = [["00:00", "24:00",0]];
        } else {
          this.parkPrices = JSON.parse(row.parkPrices);
          console.log(this.parkPrices);
        }
      },
      parkPricesSubmit(index, row) {
        this.parkPricesForm = {
          id: row.id,
          parkPrices: JSON.stringify(this.parkPrices),
        };
        let lt = this.parkPrices;
        let flag = false;
        let msg = "";
        for (var i = 0; i < lt.length; i++) {
          msg =
            lt[i][0] === null || lt[i][1] === null
              ? this.$t('siteManager.TimeCannotBeEmpty2')
              : "";
          if (msg !== "") {
            break;
          }
          for (var j = 0; j < lt.length; j++) {
            if (i != j) {
              flag =
                (lt[i][0] > lt[j][0] && lt[i][0] < lt[j][1]) ||
                (lt[i][1] > lt[j][0] && lt[i][1] < lt[j][1]);
              if (flag) {
                break;
              }
            }
          }
        }

        if (msg !== "" || flag) {
          this.$message.error(msg !== "" ? msg : this.$t('siteManager.TimeCannotBeEmpty3'));
          return;
        }
        this.$confirm(this.$t('siteManager.message1'), this.$t('siteManager.message2'), {}).then(() => {
          this.parkPricesSubmitLoading = true;
          let param = JSON.stringify(this.parkPricesForm);
          stationApi.parkPricesChange(param).then((res) => {
            this.parkPricesSubmitLoading = false;
            if (res.code === 0) {
              this.$message({
                message: res.message,
                type: "success",
              });
              this.submitStationSearchForm();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      },
      addParkPrices() {
        let length = this.parkPrices.length;
        if (length < 4) {
          console.log("length:" + length);
          if (length > 0) {
            console.log(this.parkPrices[length - 1][1]);
            if (this.parkPrices[length - 1][1] != "24:00") {
              this.parkPrices.push([this.parkPrices[length - 1][1], "24:00"]);
            } else {
              this.$message.error(this.$t('zui-wan-shi-jian-yi-jing-shi-2400-leo'));
            }
          } else {
            this.parkPrices.push(["00:00", "24:00",0]);
          }
        } else {
          this.$message.error(this.$t('deviceControl.error2'));
        }
      },
      deleteParkPrices() {
        this.parkPrices.splice(this.parkPrices.indexOf(["00:00", "24:00",0]), 1);
      },
      showViewVisible(index,row){
        this.$emit('showViewVisible',index,row)
      },
      stationEdit(index,row){
        this.$emit('stationEdit',index,row)
      },
      rateEdit(rateId){
        this.$emit('rateEdit',rateId)
      },
      stationDelete(index,row){
        this.$emit('stationDelete',index,row)
      },
      submitStationSearchForm() {
        this.$emit('submitStationSearchForm')
      }
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped>
  .parkPricesPicker {
    width: 96px !important;
    margin-bottom: 2px;
  }

  .parkPrices {
    background-color: #d949c8;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/siteManager/list.vue